import React from 'react';
import ReactDOM from 'react-dom/client';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css'; // Opcjonalne: animacje
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

console.log("Montuję AuthProvider z pliku: ", __filename || "nie wiem");
root.render(
  <React.StrictMode>
    <AuthProvider>
		<HelmetProvider>
			<App />
		</HelmetProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
